
export const doLogout = () => {
  return (dispatch, getState, services) => {
    services.http.postJson("/logout")
      .finally(() => window.location.reload());
  }
};
